module.exports = __webpack_public_path__ + "img/web_pr_01.85f6bb97.png";